import React, { Component } from "react";
import { Form, Spinner } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { BaseUrl, Authorization, LogoutFunction } from "../static.js";

export default class ValidationCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationCodeErrorText: "",
      validationCodeValue: "",
      buttonSpinner: false,
      buttonDisabled: false,
      actionError: "",
      time: {},
      seconds: 0,
      showResend: false,
    };
    this.validationCodeHandleChange =
      this.validationCodeHandleChange.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);

    this.validationCodeInput = React.createRef();
  }

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    hours = hours + "";
    minutes = minutes + "";
    seconds = seconds + "";

    let obj = {
      h: hours.padStart(2, "0"),
      m: minutes.padStart(2, "0"),
      s: seconds.padStart(2, "0"),
    };
    return obj;
  }

  componentDidMount() {
    this.props.onSubmitMobile();
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      this.validationCodeInput.current.focus();
      this.startTimer();
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startTimer() {
    let totalsecend = 180;
    this.setState({
      seconds: totalsecend,
      time: this.secondsToTime(totalsecend),
    });
    this.timer = setInterval(this.countDown, 1000);
    this.setState({ showResend: false });
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      this.setState({ showResend: true });
      clearInterval(this.timer);
    }
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onConfirm();
    }
  }

  validationCodeHandleChange(event) {
    this.setState({ validationCodeValue: event.target.value });
  }

  onConfirm() {
    this.setState({ actionError: "" });

    if (this.state.validationCodeValue === "") {
      this.setState({ actionError: "کد را وارد کنید" });
      return;
    } else {
      this.setState({ actionError: "" });
    }

    if (this.state.validationCodeValue.length === 5) {
      this.setState({ actionError: "" });
    } else {
      this.setState({ actionError: "کد وارد شده معتبر نیست" });
      return;
    }

    this.setState({ buttonSpinner: true, buttonDisabled: true });

    let data = {
      mobile: sessionStorage.getItem("mobile"),
      code: this.state.validationCodeValue,
    };

    let apitype = "";
    if (sessionStorage.getItem("userStatus") === "signup") {
      apitype = "checkCode";
    } else {
      apitype = "codeForgetAuthorize";
    }

    fetch(BaseUrl + "" + apitype, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          sessionStorage.setItem("token", result.token);
          this.props.onValidatedCode();
        } else if (result.status === 401) {
          this.setState({ actionError: "کد وارد شده معتبر نیست" });
          this.setState({ buttonSpinner: false, buttonDisabled: false });
        } else {
          this.setState({
            buttonSpinner: false,
            buttonDisabled: false,
            actionError:
              "اتصال با سرور با مشکل مواجه شد. از اتصال دستگاه به اینترنت اطمینان حاصل فرمائید.",
          });
        }
      });
  }

  resendCode() {
    this.setState({ actionError: "" });

    // let country='';
    // let number='';
    // if (isValidPhoneNumber(sessionStorage.getItem("mobile")) && isPossiblePhoneNumber(sessionStorage.getItem("mobile"))){
    //     let numberInfo=parsePhoneNumber(sessionStorage.getItem("mobile"));
    //     country=numberInfo.country;
    //     number=numberInfo.number;
    //     this.setState({actionError:''})
    // }else{
    //     this.setState({actionError:'incorrect number. please enter your number with country code'})
    //     return;
    // }

    let data = {
      mobile: sessionStorage.getItem("mobile"),
      country: "IR",
    };
    this.setState({ buttonDisabled: true });
    let apitype = "";
    if (sessionStorage.getItem("userStatus") === "signup") {
      apitype = "checkUser";
    } else {
      apitype = "forgetPassword";
    }

    fetch(BaseUrl + "" + apitype, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200 || result.status === 404) {
          this.startTimer();
          this.setState({
            showResend: false,
            buttonSpinner: false,
            buttonDisabled: false,
          });
        } else {
          this.setState({
            buttonSpinner: false,
            buttonDisabled: false,
            actionError:
              "اتصال با سرور با مشکل مواجه شد. از اتصال دستگاه به اینترنت اطمینان حاصل فرمائید.",
          });
        }
      });
  }

  onGoBack() {
    this.props.onValidatedCodeBack();
  }

  render() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      return (
        <div className="ValidationCodePage">
          <div className="inputHeader">
            <div style={{ display: "flex", flexDirection: "row" }}>
              تلفن همراه:&nbsp;
              <div style={{ direction: "ltr" }}>
                {sessionStorage.getItem("mobile").replace("+98", "0")}
              </div>
            </div>
            <div>
              {this.state.time.m}:{this.state.time.s}
            </div>
          </div>
          <Form.Control
            maxLength="5"
            className={
              this.state.actionError !== ""
                ? "inputStyle validationCode inputStyleError"
                : "inputStyle validationCode"
            }
            style={{ direction: "ltr" }}
            placeholder="کد را وارد کنید"
            type="text"
            name="validationCode"
            id="validationCode"
            onChange={this.validationCodeHandleChange}
            value={this.state.validationCodeValue}
            disabled={this.state.buttonDisabled}
            onKeyPress={this.handleKeyPress.bind(this)}
            ref={this.validationCodeInput}
          />

          <div className="errorMessageContainer">{this.state.actionError}</div>

          {!this.state.showResend && !this.state.buttonDisabled && (
            <div
              onClick={
                this.state.buttonDisabled
                  ? (event) => event.preventDefault()
                  : this.onConfirm
              }
              className="linkStyle"
            >
              تایید
            </div>
          )}
          {this.state.showResend && !this.state.buttonDisabled && (
            <div
              onClick={
                this.state.buttonDisabled
                  ? (event) => event.preventDefault()
                  : this.resendCode.bind(this)
              }
              className="linkStyle"
            >
              ارسال مجدد
            </div>
          )}
          {this.state.buttonDisabled && (
            <Spinner
              style={{
                color: "var(--brown)",
                height: "20px",
                width: "20px",
                marginTop: "20px",
              }}
              animation="border"
            />
          )}
        </div>
      );
    } else {
      return <Redirect to="/Login" />;
    }
  }
}
